import PlagiarismOrder from '@/models/read/PlagiarismOrder';
import jsonapi from 'jsonapi-parse';
import FreemiumPlagiarismCheckReport from '~/models/read/FreemiumPlagiarismCheck/FreemiumPlagiarismCheckReport';
import FreemiumPlagiarismSubmissionStatus
    from '~/models/read/FreemiumPlagiarismCheck/FreemiumPlagiarismSubmissionStatus';
import Cookie from 'js-cookie';
import PlagiarismBundle from '~/models/read/PlagiarismBundle';

export default $axios => () => ({
    async list() {
        let response = await $axios.$get(`/api/v1/plagiarism/orders`);
        return jsonapi.parse(response).data.map(o => new PlagiarismOrder(o)).sort((a, b) => a.id > b.id ? -1 : 1);
    },

    async get(id) {
        let response = await $axios.$get(`/api/v1/plagiarism/orders/${id}`);
        return new PlagiarismOrder(jsonapi.parse(response).data);
    },

    async getReport(id) {
        let response = await $axios.$get(`/api/v1/plagiarism/orders/${id}/report`);
        return jsonapi.parse(response).data;
    },

    async getExampleReport() {
        let response = await $axios.$get(`/api/v1/plagiarism/example/report`, { withCredentials: false, ignoreLogout: true });
        return jsonapi.parse(response).data;
    },

    async getSubmissionStatus(id) {
        let response = await $axios.$get(`/plagiarism-check/free/${id}/status`, { withCredentials: true, ignoreLogout: true });
        return new FreemiumPlagiarismSubmissionStatus(jsonapi.parse(response).data[0]);
    },

    async submitFreePlagiarismCheck(id) {
        let formData = new FormData();
        let cookie = Cookie.get('_gaexp');
        formData.append('_gaexp', typeof cookie === 'undefined' ? null : cookie);
        if (window.marketing && window.marketing.getAmplitudeDeviceId()) {
            formData.append('deviceId', window.marketing.getAmplitudeDeviceId());
        }

        let response = await $axios.$post(`/plagiarism-check/free/${id}/submit`, formData, {
            withCredentials: true,
            ignoreLogout: true,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return jsonapi.parse(response).data;
    },

    async getFullReportPrice(id) {
        let response = await $axios.$get(`/plagiarism-check/free/${id}/full-report-price`, {
            withCredentials: true,
            ignoreLogout: true,
        });
        return new FreemiumPlagiarismCheckReport(jsonapi.parse(response).data[0]);
    },

    async getGrammarCheckMetaReport(docId) {
        return new Promise(async (resolve, reject) => {
            await $axios.$get(`/api/v1/plagiarism/grammar-check/meta-report/${docId}`, { withCredentials: false, ignoreLogout: true })
                .then((response) => {
                    resolve(jsonapi.parse(response).data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    async getAIDetectionScore(docId) {
        return new Promise(async (resolve, reject) => {
            await $axios.$get(`/api/v1/ai-score/${docId}`, { withCredentials: false, ignoreLogout: true })
                .then((response) => {
                    resolve(jsonapi.parse(response).data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    async listFreemium() {
        let response = await $axios.$get(`/api/v1/plagiarism/freemium-checks`);
        return jsonapi.parse(response).data;
    },

    async deleteFreePlagiarismCheck(id) {
        let response = await $axios.delete(`/api/v1/plagiarism/freemium-checks/remove/${id}`);
        return jsonapi.parse(response).data;
    },

    async updateModalViewed() {
        let response = await $axios.$post(`/api/v1/plagiarism/new-report-modal-viewed/`);
        return response;
    },

    async getBundle() {
        let response = await $axios.$get(`/api/v1/plagiarism/ongoing-bundle/`);
        return new PlagiarismBundle(jsonapi.parse(response).data);
    },

    async getAiDetectorIframe(documentId) {
        let response = await $axios.$get(`/api/v1/documents/${documentId}/premium-ai-detector-url`);
        return response.data;
    },
});
